import AWS from 'aws-sdk';
import { uploadVideoToApi } from 'api/requests';
import { chatTemporaryFiles } from 'api';

// DigitalOcean Spaces credentials from environment variables
const SPACES_ACCESS_KEY_ID = process.env.REACT_APP_DO_SPACES_ACCESS_KEY_ID;
const SPACES_SECRET_ACCESS_KEY = process.env.REACT_APP_DO_SPACES_SECRET_ACCESS_KEY;
const REGION = process.env.REACT_APP_DO_SPACES_REGION;
const ENDPOINT = process.env.REACT_APP_DO_SPACES_ENDPOINT;

export const configureS3 = () => {
  if (!SPACES_ACCESS_KEY_ID || !SPACES_SECRET_ACCESS_KEY) {
    console.error('❌ DigitalOcean Spaces credentials not found!');
    return false;
  }

  AWS.config.update({
    accessKeyId: SPACES_ACCESS_KEY_ID,
    secretAccessKey: SPACES_SECRET_ACCESS_KEY,
    region: REGION,
    endpoint: ENDPOINT
  });
  
  return true;
}

export const uploadFile = async (file, path) => {
  try {
    const configSuccess = configureS3();
    if (!configSuccess) {
      throw new Error('Failed to configure DigitalOcean Spaces credentials');
    }

    // Create S3 client for DigitalOcean Spaces
    const s3 = new AWS.S3(); // eslint-disable-line

    const MAX_SIZE_IMAGE_PDF = 5 * 1024 * 1024; // 5MB
    const MAX_SIZE_VIDEO = 50 * 1024 * 1024; // 50MB

    const fileType = file.type.split('/')[0];
    const isVideo = fileType === 'video';

    // Check file size limits
    if ((isVideo && file.size > MAX_SIZE_VIDEO) || (!isVideo && file.size > MAX_SIZE_IMAGE_PDF)) {
      throw new Error(`File size exceeds the allowed limit: ${isVideo ? '50MB for videos' : '5MB for images/PDFs'}`);
    }

    // Handle video uploads through API
    if (isVideo) {
      const apiResponse = await uploadVideoToApi(chatTemporaryFiles, file);
      return apiResponse;
    }
    
    const upload = new AWS.S3.ManagedUpload({
      partSize: isVideo ? 10 * 1024 * 1024 : undefined,
      queueSize: 2,
      params: {
        ACL: 'public-read',
        ContentType: file.type,
        Bucket: 'static.pibox.app',
        Key: `${path}/${file.name}`,
        Body: file
      }
    });

    // Track upload progress
    upload.on('httpUploadProgress', (progress) => {
      const percentComplete = Math.round((progress.loaded / progress.total) * 100);
      console.log(`📤 Upload progress: ${percentComplete}% (${progress.loaded} of ${progress.total} bytes)`);
    });

    const result = await upload.promise();
    console.log('✅ File uploaded successfully:', result.Location);
    return result;
    
  } catch (error) {
    console.error("❌ Error uploading the file:", error.message || error);

    if (error.message.includes('CORS')) {
      console.error("⚠️ Check your CORS configuration in DigitalOcean Spaces.");
    }

    throw error; 
  }
};

// Helper function to test connection
export const testConnection = async () => {
  try {
    const configSuccess = configureS3();
    if (!configSuccess) {
      return { success: false, error: 'Configuration failed' };
    }

    const s3 = new AWS.S3();
    
    // Try to list buckets to test connection
    const result = await s3.listBuckets().promise();
    console.log('✅ Connection test successful:', result);
    return { success: true, buckets: result.Buckets };
  } catch (error) {
    console.error('❌ Connection test failed:', error);
    return { success: false, error: error.message };
  }
};
